define(function() {
    var windowTitleless = {
        window: {
            titlebar: false
        }
    };

    var routes = {
        "auth/login": {
            window: {
                titlebar: false
            }
        },
        "password/reset": {
            window: {
                titlebar: false
            }
        },
        "password/email": {
            window: {
                titlebar: false
            }
        },
        register: {
            window: {
                titlebar: false,
                width: "wide"
            }
        }
    };

    return routes;
});
